import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/esm/Spinner';

function DownloadButton({
  onClick,
  className,
  text,
  loading = false,
  disabled = false,
}) {
  return (
    <Button
      variant='primary'
      className={`d-flex bg-white text-black bg-opacity-75 align-items-center justify-content-center ${className}`}
      disabled={disabled}
      onClick={() => onClick()}
      style={{}}
    >
      {loading ? (
        <>
          <Spinner
            as='span'
            animation='border'
            size='sm'
            role='status'
            aria-hidden='true'
            className='me-2'
          />
          <span className='visually-hidden'>Loading...</span>
        </>
      ) : (
        <span
          className='material-symbols-outlined me-2'
          style={{ fontSize: '18px' }}
        >
          download
        </span>
      )}
      {text}
    </Button>
  );
}

export default DownloadButton;
